export default function Footer() {
  const now = new Date();

  return (
    <div className="h-40 w-full bg-gradient-to-b from-indigo-950 to-slate-900  flex justify-center items-center">
      <div className="flex flex-row flex-wrap text-white text-center px-3 items-center justify-center">
        <div>© {now.getFullYear()} Renee Althea Khan. </div>
        <div>&nbsp;All Rights Reserved</div>
      </div>
    </div>
  );
}
